export const vns_index = ['vns.index']
export const vns_create = ['vns.create']
export const vns_edit = ['vns.edit']

export default [].concat(
    vns_index,
    vns_create,
    vns_edit
)
